'use client'

import useEmblaCarousel from 'embla-carousel-react'
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures'
import { useMemo } from 'react'

// Follow the carousel axis: horizontal trackpad gestures move the cards,
// while vertical gestures remain available for normal page scrolling.
export default function useScrollCarousel(options, plugins = []) {
  const wheelGestures = useMemo(() => WheelGesturesPlugin(), [])
  return useEmblaCarousel({ skipSnaps: true, ...options }, [
    wheelGestures,
    ...plugins,
  ])
}
